import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISendTelegramMessageRequest } from './send-telegram-message-request';
import type { ISendTelegramMessageResponse } from './send-telegram-message-response';
import { sendTelegramMessageResponseSchema } from './send-telegram-message-response';

export async function sendTelegramMessageApi(
  body: ISendTelegramMessageRequest,
): Promise<IValidatedResponse<ISendTelegramMessageResponse>> {
  return postRequest<ISendTelegramMessageResponse>({
    path: '/sys/telegram/send',
    body,
    schema: sendTelegramMessageResponseSchema,
  });
}
